import { ClerkProvider } from '@clerk/clerk-react'
import type { ReactNode } from 'react'
import { CLERK_PUBLISHABLE_KEY } from '../config/env'

interface AuthProviderProps {
  children: ReactNode
}

export function AuthProvider({ children }: AuthProviderProps) {
  return (
    <ClerkProvider publishableKey={CLERK_PUBLISHABLE_KEY}>
      {children}
    </ClerkProvider>
  )
}
